import { classNameType } from "@/types/generalTypes";
import React from "react";

function LeftIcon({ className }: classNameType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="7"
      viewBox="0 0 4 7"
      fill="none"
    >
      <path
        d="M1.58849 3.68522C1.57103 3.6661 1.55718 3.64338 1.54772 3.61837C1.53827 3.59335 1.53341 3.56654 1.53341 3.53946C1.53341 3.51238 1.53827 3.48556 1.54772 3.46055C1.55718 3.43554 1.57103 3.41282 1.58849 3.39369L3.30824 1.50575C3.41376 1.38994 3.47306 1.23284 3.4731 1.06902C3.47313 0.905193 3.4139 0.748063 3.30843 0.632195C3.20295 0.516326 3.05988 0.451211 2.91068 0.451172C2.76149 0.451133 2.61839 0.516175 2.51286 0.631989L0.793118 2.52034C0.547407 2.79089 0.409424 3.15738 0.409424 3.53946C0.409424 3.92154 0.547407 4.28803 0.793118 4.55858L2.51286 6.44693C2.61839 6.56274 2.76149 6.62779 2.91068 6.62775C3.05988 6.62771 3.20295 6.56259 3.30843 6.44672C3.4139 6.33086 3.47313 6.17373 3.4731 6.0099C3.47306 5.84608 3.41376 5.68898 3.30824 5.57316L1.58849 3.68522Z"
        fill="#000"
        stroke="#000"
      />
    </svg>
  );
}

export default LeftIcon;
